import React, { useState } from 'react'
import HeaderDashboard from '../../Components/HeaderDashboard';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { flightUnflownTicketReport } from "../../Services/ReportsApi";

const UnflownTicket = () => {
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
    });
    const today = new Date();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleDateChange = (name, date) => {
        if (!date) {
            setFilters((prev) => ({ ...prev, [name]: "" }));
            return;
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const formatted = `${day}/${month}/${year}`;

        setFilters((prev) => ({ ...prev, [name]: formatted }));
    };

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFilters((prev) => ({ ...prev, [name]: value }));
    // };

    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                UserName: "",
            };
            const data = await flightUnflownTicketReport(requestBody);
            //console.log(data);
            setTransactions(data || []);

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reports</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Flight</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">Unflown Ticket</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <DatePicker
                                selected={parseDate(filters.fromDate)}
                                onChange={(date) => handleDateChange("fromDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="From Date"
                                maxDate={today}
                                className="form-control form-control-solid"
                            />
                        </div>

                        {/* To Date */}
                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <DatePicker
                                selected={parseDate(filters.toDate)}
                                onChange={(date) => handleDateChange("toDate", date)}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="To Date"
                                minDate={parseDate(filters.fromDate)}     // disable before fromDate
                                maxDate={today}                           // disable future dates
                                className="form-control form-control-solid"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="wraper">
                <div className="box_shadow">
                    <div className="table-responsive">
                        <table className="table align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="ps-4">Sr No</th>
                                    <th>Origin</th>
                                    <th>Destination</th>
                                    <th>Airline</th>
                                    <th>PNR No</th>
                                    <th>Ref No</th>
                                    <th>Journey Date</th>
                                    <th>Booking Date</th>
                                    <th>Status</th>
                                    <th>No. of Pax</th>
                                    <th>Net Payable</th>
                                    {/* <th className="text-center">Action</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>@item.origin</td>
                                            <td>@item.destination</td>
                                            <td>@item.airline</td>
                                            <td>@item.pNR</td>
                                            <td>@item.referenceNo</td>
                                            <td>@item.departureDate  </td>
                                            <td>@item.bookingDate</td>
                                            <td>@item.transactionStatus</td>
                                            <td>@(item.noOfPax - item.noOfCancelPax)</td>
                                            <td>@item.totalAmount.ToString("N2")</td>
                                            {/* <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() =>
                                                        navigate(
                                                            `/Reservations/Flight/TransactionDetails?referenceNo=${item.referenceNo}`
                                                        )
                                                    }
                                                >
                                                    View
                                                </button>
                                            </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center text-muted">
                                            {loading ? "Loading..." : "No records found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default UnflownTicket
